import { render, staticRenderFns } from "./CalculoFlowEditor.vue?vue&type=template&id=0b3c92b4&scoped=true&"
import script from "./CalculoFlowEditor.vue?vue&type=script&lang=js&"
export * from "./CalculoFlowEditor.vue?vue&type=script&lang=js&"
import style0 from "./CalculoFlowEditor.vue?vue&type=style&index=0&id=0b3c92b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c92b4",
  null
  
)

export default component.exports